import React from 'react';
import { Helmet } from 'react-helmet';
import { BASE_URL, DEFAULT_OG_IMAGE } from './constants';
const PageMeta = ({ title, description, canonical, ogImage, noIndex, noFollow = false, jsonLd, }) => {
    const fullTitle = `${title} | MarineSamraj`;
    const image = ogImage ?? DEFAULT_OG_IMAGE;
    const canonicalURL = canonical ? `${BASE_URL}/${canonical}` : undefined;
    return (React.createElement(Helmet, null,
        React.createElement("title", null, fullTitle),
        description && React.createElement("meta", { name: "description", content: description }),
        canonicalURL && React.createElement("link", { rel: "canonical", href: canonicalURL }),
        (noIndex || noFollow) && React.createElement("meta", { name: "robots", content: [noIndex && "noindex", noFollow && "nofollow"].filter(Boolean).join(", ") }),
        React.createElement("meta", { property: "og:title", content: fullTitle }),
        description && React.createElement("meta", { property: "og:description", content: description }),
        React.createElement("meta", { property: "og:image", content: image }),
        React.createElement("meta", { property: "og:site_name", content: "MarineSamraj" }),
        React.createElement("meta", { name: "twitter:card", content: "summary_large_image" }),
        React.createElement("meta", { name: "twitter:title", content: fullTitle }),
        description && React.createElement("meta", { name: "twitter:description", content: description }),
        React.createElement("meta", { name: "twitter:image", content: image }),
        jsonLd && (React.createElement("script", { type: "application/ld+json" }, JSON.stringify(jsonLd)))));
};
export default PageMeta;
